import { Navigate } from 'react-router-dom'
import { ROUTES } from '@/config/routes'
import { useCurrentClient } from '@/features/auth/state/auth'

const ClientPortalRoute = ({ children }: { children: JSX.Element }) => {
  const client = useCurrentClient()

  if (!client) {
    return <Navigate to={ROUTES.LOGIN_CLIENT.path} replace />
  }

  return children
}

export default ClientPortalRoute
